import { render, staticRenderFns } from "./EmpresasAdmin.vue?vue&type=template&id=334d3fb9&scoped=true"
import script from "./EmpresasAdmin.vue?vue&type=script&lang=js"
export * from "./EmpresasAdmin.vue?vue&type=script&lang=js"
import style0 from "./EmpresasAdmin.vue?vue&type=style&index=0&id=334d3fb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334d3fb9",
  null
  
)

export default component.exports